<template>
  <div>
    <list row-key="Record" ref="list" unit="客户期初应收" page show-index show-query :get-data-func="getDataFunc" show-checkbox
      @check-change="x => DelArDetails = x">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onImprot">导入</el-button>
        <el-button type="primary" plain @click="reviewAll">批量审核</el-button>
        <el-button type="danger" plain @click="backAll">批量弃审</el-button>
        <el-button type="primary" @click="onAdd">添加</el-button>
        <el-button type="primary" @click="onSave" plain>保存</el-button>
        <el-button type="danger" @click="onDelete">删除</el-button>
      </template>
      <template slot="query">
        <el-form-item label="客户编号">
          <el-input v-model="params.TradeUnitNo" placeholder="请输入客户编号" />
        </el-form-item>
        <el-form-item label="客户名称">
          <el-input v-model="params.TradeUnitName" placeholder="请输入客户名称" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column label="期初单日期" prop="OrigDate" min-width="170">
          <template slot-scope="{row}">
            <span v-if="row.Status == 1">{{ $commonJs.toDateString(row.OrigDate) }}</span>
            <el-date-picker v-else v-model="row.OrigDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="onChange(row)"
              style="width: 140px;"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column min-width="140" align="left" label="客户编码" prop="TradeUnitNo" />
        <el-table-column min-width="180px" align="left" label="客户名称">
          <template slot-scope="{row}">
            <span v-if="row.Status == 1">{{ row.TradeUnitName }}</span>
            <el-select v-else v-model="row.TradeUnitId" filterable @change="changeTu($event, row)">
              <el-option v-for="(i, k) in tradeUnitList" :key="k" :value="i.TradeUnitId" :label="i.FullName" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column min-width="100" align="left" label="预收">
          <template slot-scope="{ row }">
            <span v-if="row.Status == 1">{{ row.OrigPrepayAmount }}</span>
            <el-input v-else v-model="row.OrigPrepayAmount" @change="onInput(row, 'OrigPrepayAmount')" placeholder="请输入预收" />
          </template>
        </el-table-column>
        <el-table-column min-width="100" align="left" label="应收">
          <template slot-scope="{ row }">
            <span v-if="row.Status == 1">{{ row.Amount }}</span>
            <el-input v-else v-model="row.Amount" @change="onInput(row, 'Amount')" placeholder="请输入应收" />
          </template>
        </el-table-column>
        <el-table-column align="right" label="期初余额">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toThousands(getQuantity(row.OrigBalanceAmount)) }}</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>

import listMixin from "@/mixins/list";
import optionMixins from "@/mixins/option";
import list from "@/components/common/list";
import importDialog from "./importDialog";

export default {
  mixins: [listMixin, optionMixins],
  components: { list, importDialog },
  data() {
    return {
      api: require("@/api/rp/originalAmount").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      tradeUnitList: [],
      params: {
        TradeUnitNo: "",
        TradeUnitName: ""
      },
      data: {
        Id: 0,
        // OriginalDate: null,
        // AddUserId: null,
        // AddUserName: "",
        // Status: 0,
        ArDetails: [], //应收明细
      },
      DelArDetails: [],
    };
  },
  mounted() {
    this.callOptionApi();
    this.tradeUnitApi.list({ TradeUnitTypes: [0, 2], Status: 1 }).then((res) => {
      if (res.Code == 0) this.tradeUnitList = res.Data;
    });
  },
  methods: {
    onImprot() {
      this.$refs.importDialog.open();
    },
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.arDetailList(params).then(res => {
          if (res.Data && res.Data.length > 0) {
            this.data.Id = res.Data[0].OriginalAmountId
          }
          res.Data = res.Data.map(x => ({ ...x, T: null }))
          resolve(res);
        })
      })
    },
    changeTu(id, row) {
      if (row.T !== 0) row.T = 1;
      var tu = this.tradeUnitList.find(x => x.TradeUnitId == id);
      row.TradeUnitNo = tu.TradeUnitNo;
    },
    onChange(row) {
      if (row.T !== 0) row.T = 1;
    },
    onInput(row, type) {
      if (row.T !== 0) row.T = 1;
      row[type] = parseFloat(Number(row[type]).toFixed(2));
      if (row.OrigPrepayAmount || row.Amount) {
        row.OrigBalanceAmount = Number(row.Amount) - Number(row.OrigPrepayAmount);
      }
    },
    onAdd() {
      this.$refs.list.data.push({
        Id: 0,
        OriginalAmountId: this.data.Id,
        OrigBalanceAmount: null, //期初余额
        Amount: null, //应收应付
        OrigPrepayAmount: null, //预收预付
        TradeUnitId: null,
        TradeUnitNo: "",
        OrigDate: null,
        T: 0,
      });
    },
    onDelete() {
      if (this.DelArDetails.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        console.log("删除", this.DelArDetails);
        var ids = this.DelArDetails.filter(x => x.Id > 0).map(x => x.Id)

        var data = this.$refs.list.data;
        this.DelArDetails.forEach((x) => {
          var index = data.indexOf(x);
          this.$refs.list.data.splice(index, 1);
        });

        if (ids.length > 0) {
          this.api.arDelete({ ids: ids }).then((res) => {
            if (res.Code == 0) {
              this.$message.success("删除成功");
              // this.reload();
            } else {
              this.$message.error("删除失败");
              // this.reload();
            }
          })
        }
      }).catch(() => { });
    },
    onSave() {
      var listData = this.$refs.list.data;

      var data = this.$commonJs.obj.removeNullKey({ ...this.data });
      data.ArDetails = listData.filter(x =>
        x.TradeUnitId ||
        x.OrigPrepayAmount ||
        x.Amount ||
        x.OrigBalanceAmount ||
        x.OrigDate);

      console.log("data", JSON.parse(JSON.stringify(data)));

      if (data.ArDetails.some(x => !x.OrigDate)) {
        this.$message.warning("期初单日期不能为空");
        return;
      }
      if (data.ArDetails.some(x => !x.TradeUnitId)) {
        this.$message.warning("请选择客户");
        return;
      }
      if (data.ArDetails.some(x => !x.Amount && !x.OrigPrepayAmount)) {
        this.$message.warning("应收和预收不能同时为空");
        return;
      }

      data.ArDetails = data.ArDetails.filter(x => x.T != null);
      data.ArDetails.forEach(x => {
        if (!x.OrigPrepayAmount) x.OrigPrepayAmount = 0;
        if (!x.Amount) x.Amount = 0;
      })

      console.log("save");
      // return;
      var loading = this.$loading({
        lock: true,
        text: "正在保存...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.save(data).then(res => {
        if (res.Code == 0) {
          loading.close();
          this.$message.success(res.Msg);
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    reviewAll() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要审核的数据");
        return;
      }
      this.$confirm("确认审核所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => item.Id);
        this.api.arReview({ ids }).then(res => {
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        })
      }).catch(() => { });
    },
    backAll() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要弃审的数据");
        return;
      }
      this.$confirm("确认弃审所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => item.Id);
        this.api.arBack({ ids }).then(res => {
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        })
      }).catch(() => { });
    }
  }
};
</script>
